<script>
	export let h1 = '';
</script>

{#if h1}
	<header><h1>{h1}</h1></header>
{/if}

<style>
	header {
		background-color: var(--covBlue);
		color: white;
		padding: 0.75em 1em;
	}
	h1 {
		font-size: 1.1rem;
		margin: 0 auto;
		text-align: center;
	}
</style>
